/*
  Schrittwahl im Anwendungs-Abschnitt.

  Ein Klick auf eine Schrittkarte zeigt das zugehoerige Bild. Ohne
  JavaScript bleibt der erste Schritt sichtbar, die Inhalte sind also
  nicht davon abhaengig.
*/
(function () {
  function init(wrapper) {
    if (wrapper.dataset.bereit === "1") return;
    wrapper.dataset.bereit = "1";
    wrapper.addEventListener("click", function (e) {
      var knopf = e.target.closest("[data-hss-schritt]");
      if (!knopf) return;
      var nr = knopf.dataset.hssSchritt;
      wrapper.querySelectorAll("[data-hss-schritt]").forEach(function (k) {
        var an = k === knopf;
        k.classList.toggle("hss-det__schritt--aktiv", an);
        k.setAttribute("aria-pressed", an ? "true" : "false");
      });
      wrapper.querySelectorAll("[data-hss-figur]").forEach(function (f) {
        f.classList.toggle("hss-det__figur--aus", f.dataset.hssFigur !== nr);
      });
    });
  }
  function start() { document.querySelectorAll("[data-hss-schritte]").forEach(init); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", start); } else { start(); }
  document.addEventListener("shopify:section:load", start);
})();
